const comments = [
  {
    id: 1,
    name: '电影爱好者小李',
    content: '被窝影院真的太良心了！没有广告这一点就秒杀90%的影视网站。片源也很全，我想看的老片基本都能找到，播放也很流畅。已经推荐给身边所有朋友了！',
    time: '3天前',
    likes: 256,
  },
  {
    id: 2,
    name: '追剧达人Amy',
    content: '自从发现被窝影院，就再也没去过别的网站了。更新速度很快，新片下线没多久就能看到高清版。手机端体验也很棒，通勤路上看片太方便了。',
    time: '5天前',
    likes: 189,
  },
  {
    id: 3,
    name: '文艺片重度患者',
    content: '作为一个文艺片爱好者，被窝影院的片库真的让我惊喜。很多小众文艺片和纪录片都能找到，分类也很清晰。希望平台能一直保持这样的品质！',
    time: '1周前',
    likes: 142,
  },
  {
    id: 4,
    name: '带娃看电影的老爸',
    content: '动画电影专区做得很好，分类详细、画质清晰。周末带孩子一起看电影成了固定节目。无广告这点对有小孩的家庭来说太重要了，不用担心孩子看到不合适的广告内容。',
    time: '2周前',
    likes: 98,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">影迷热评</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">来自真实影迷的使用反馈与观影感受</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="p-5 rounded-xl bg-background-100 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-accent-700 font-heading">{comment.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}